import React, { Component } from "react";
import Container from "./Container";
import Row from "./Row";
import Col from "./Col";
import Card from "./Card";
import SearchForm from "./SearchForm";
import MovieDetail from "./MovieDetail";
import API from "../utils/API";

class OmdbContainer extends Component {
    state = {
        result: {},
        search: ""
    };

    componentDidMount() {
        this.searchMovies("The Matrix");
    }

    searchMovies = query => {
        API.search(query)
        .then(res => this.setState({ result: res.data }))
        .catch(err => console.log(err));
    };

    handleInputChange = event => {
        const value = event.target.value;
        const name = event.target.name;
        this.setState({
            [name]: value
        });
    };

    handleFormSubmit = event => {
        event.preventDefault();
        this.searchMovies(this.state.search);
    };

    render() {
        return (
            <Container>
                <Row>
                    <Col size="md-8">
                        <Card
                            heading={this.state.result.Title || "Search For a Movie to Begin"} 
                        >
                            {this.state.result.Title ? (
                                <MovieDetail
                                title={this.state.result.Title}
                                src={this.state.result.Poster}
                                released={this.state.result.Released}
                                rated={this.state.result.Rated}
                                genre={this.state.result.Genre}
                                actors={this.state.result.Actors}
                                director={this.state.result.Director}
                                plot={this.state.result.Plot}
                                runtime={this.state.result.Runtime}
                            />
                            ) : (
                                <h3>No Result to Display</h3>
                            )}
                        </Card>
                    </Col>
                    <Col size="md-4">
            <Card heading="Search">
              <SearchForm
                value={this.state.search}
                handleInputChange={this.handleInputChange}
                handleFormSubmit={this.handleFormSubmit}
              />
            </Card>
          </Col>
        </Row>
      </Container>
        );
    }
}

export default OmdbContainer;